export default __webpack_public_path__ + "static/media/david1.dfcaa634.jpg";